import { render, staticRenderFns } from "./WithLoader.vue?vue&type=template&id=59d99c8a&scoped=true&"
import script from "./WithLoader.vue?vue&type=script&lang=js&"
export * from "./WithLoader.vue?vue&type=script&lang=js&"
import style0 from "./WithLoader.vue?vue&type=style&index=0&id=59d99c8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d99c8a",
  null
  
)

export default component.exports